const riot = require('riot');

riot.tag2('popup-suggestion-filters', '<div class="w250 py8 px4" ref="popup"> <div class="f fm flex-between"> <div class="bold fs13 mb8">フィルター一覧</div> </div> <div class="block outline-none" ref="target" onkeydown="{selectionList.onKeyDown}" tabindex="0"> <div class="overflow-y-scroll scrollbar-none max-height-168"> <div each="{item, index in filterSettings.suggestions}" data-is="item-selection-list" item="{item}" onclick="{setValue}" selected-class="bg-pale"> <div class="relative f fm w-full py4 text-primary cursor-pointer px2 tooltip" aria-label="{item.value}" data-tooltip-position="top"><i class="icon-template mr4"></i> <div class="w-full flex-fixed lh15 bold fs12 line-clamp-1 word-break-all mr5">{item.label || ⁗Untitled⁗}</div><i class="icon-close absolute z100 t0 b0 r0 f fh h-full p6 fs16 cursor-pointer" onclick="{parent.onDelete}"></i> </div> </div> <div class="f fh p8"> <button class="button pale fs10" onclick="{onSave}">今のフィルタを保存する</button> </div> </div> </div> </div>', '', 'class="bg-white box-shadow-primary rounded-8"', function(opts) {

    this.mixin('selectionList');
    this.on('mount', async () => {

      this.filterSettings = app.localStorageManager.getFromStorage(app.data.filter_settings_key);

      if (!this.filterSettings.suggestions) {
        this.filterSettings.suggestions = [];
      }

      requestAnimationFrame(() => {
        this.refs.target.focus();
      });
    });

    this.setValue = () => {
      this.value = this.filterSettings.suggestions[this.selectionList.selectedIndex].value;
      this.close();
    };

    this.on('selectionList.keydown.enter', () => {
      this.setValue();
    });

    this.onSave = () => {
      if (!opts.value) {
        spat.modal.alert('フィルタが何も入力されていません。');
        return ;
      }

      let label = prompt('フィルタ名を入力してください', this.opts.value);
      if (!label) {
        return;
      }

      this.filterSettings.suggestions.push({
        label,
        value: this.opts.value,
      });

      app.localStorageManager.saveToStorage(app.data.filter_settings_key, this.filterSettings);

      this.update();
    };

    this.onDelete = (e) => {
      e.stopPropagation();

      this.filterSettings.suggestions.splice(this.selectionList.selectedIndex, 1);
      app.localStorageManager.saveToStorage(app.data.filter_settings_key, this.filterSettings);

      this.update();
    };
});